
export default function enhancer() {
    return (createStore: any) => (reducer: any, preloadedState: any) => {
        const local = window.localStorage.getItem('__state');
        const session = window.sessionStorage.getItem('__state'); 
        // Per tab
        if (session) {
            preloadedState = { ...preloadedState, ...JSON.parse(session) };
        }
        // Per browser
        if (local) {
            preloadedState = { ...preloadedState, ...JSON.parse(local) };
        }
        const store = createStore(reducer, preloadedState);     
        window.addEventListener('unload', (event: any) => {
            // event.waitUntil(async function() {
            //     // Feature-detect
            //     if (this.registration.navigationPreload) {
            //       // Enable navigation preloads!
            //       await this.registration.navigationPreload.enable();
            //     }
            // }());
            // Per browser
            const { pageFilter, notemenu } = store.getState();
            window.localStorage.setItem('__state', JSON.stringify({ notemenu }));

            // Per tab
            const { notesEditor, flyover, admin, beheer, beheerEditor, bookmarksEditor, categoriesEditor, filter, selectionrelation, noteParticipantSelectPopup, questionNoteSelectPopup, questionsEditor, questionReducer, notesReducer, usergroupEditor, notechatEditor, questionaddresseeEditor } = store.getState();
            window.sessionStorage.setItem('__state', JSON.stringify({ notesEditor, flyover, admin, beheer, beheerEditor, bookmarksEditor, categoriesEditor, 
                                                                        filter, pageFilter, selectionrelation, noteParticipantSelectPopup, questionNoteSelectPopup, questionsEditor, questionReducer, notesReducer, usergroupEditor, notechatEditor, questionaddresseeEditor }));
                                                                        
        });  
        return store;
    };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/store/persistent.tsx